var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"elem"},[(_vm.elem)?_vm._t("default",null,{"elem":_vm.elem}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }